'use strict';

var React = require('react');
var styled = require('styled-components');
var component$2 = require('../Button/component.js');
var component = require('../Dropdown/component.js');
require('../Dropdown/Item.js');
require('../Dropdown/ItemGroup.js');
var index = require('../Flex/index.js');
var component$1 = require('../forms/Checkbox/component.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const DropdownOverlayStyled = styled__default.default(component.Dropdown) `
  border-radius: 12px;
  padding: 6px;
`;
const DropdownStyled = styled__default.default(React.forwardRef(function DropdownStyled({ className, ...props }, ref) {
    return React__default.default.createElement(DropdownOverlayStyled, { ref: ref, targetClassName: className, ...props });
})) `
  display: block;
`;
const Items = styled__default.default.div `
  min-width: 250px;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;
const CheckboxStyled = styled__default.default(React.forwardRef(function CheckboxStyled({ className, ...props }, ref) {
    return React__default.default.createElement(component$1.Checkbox, { ref: ref, containerClassName: className, ...props });
})) `
  padding: 4px;
  border-radius: 8px;

  ${({ checked }) => checked && `background: #ebf3fe;`}
  &:focus {
    box-shadow: none;
  }
`;
const ItemLabel = styled__default.default.span `
  font-size: 13px;
`;
const ButtonTarget = styled__default.default(component$2.Button) `
  ${({ $displayClearIcon }) => $displayClearIcon && `padding-right: 40px;`}
  ${({ $fullWidth }) => ($fullWidth ? `width: 100%;` : `max-width: 100%;`)}
    i {
    width: 20px;
    height: 20px;
    margin-top: -2px;
    margin-left: -2px;
    font-size: 20px;
  }

  ${index.Flex.Row} {
    flex-wrap: nowrap;
    justify-content: start;
  }

  ${index.Flex.Row} > span {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
const Title = styled__default.default.span `
  font-weight: 500;
`;
const ButtonClear = styled__default.default(component$2.Button) `
  padding: 9px;
  margin-left: -34px;
  border-color: transparent;
  background-color: transparent;

  &:hover,
  &:focus {
    border-color: transparent;
    background-color: #f7f7f7;
  }
`;

exports.ButtonClear = ButtonClear;
exports.ButtonTarget = ButtonTarget;
exports.Checkbox = CheckboxStyled;
exports.Dropdown = DropdownStyled;
exports.ItemLabel = ItemLabel;
exports.Items = Items;
exports.Title = Title;
//# sourceMappingURL=styles.js.map
